/**
 * Constantes de configuración para MapToolBar
 */
export const SEARCH_CONFIG = {
  MIN_CHARACTERS_FOR_PLACES: 5,
  DEBOUNCE_DELAY_MS: 750,
  MAX_RESULTS_DEVICES: 5,
  MAX_RESULTS_PLACES: 5,
};

export const MENU_CONFIG = {
  WIDTH: 500,
  MAX_HEIGHT: 400,
};

export const RESPONSIVE_CONFIG = {
  COLLAPSED_WIDTH: 1200,
};

export const ITEM_TYPES = {
  AI_SEARCH: 'ai-search',
  PLACE: 'place',
  CAMERAS: 'cameras',
  BUSES: 'buses',
  LPRS: 'lprs',
  DEVICES: 'devices',
  SENSORS: 'sensors',
  INCIDENTS: 'incidents',
};
